/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Settings_Sub_Credits_ReviewerInputs */

const en_settings_sub_credits_reviewer = /** @type {(inputs: Settings_Sub_Credits_ReviewerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} Pemeriksa reviews`)
};

const id_settings_sub_credits_reviewer = /** @type {(inputs: Settings_Sub_Credits_ReviewerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} pemeriksaan Pemeriksa`)
};

/**
* | output |
* | --- |
* | "{n} Pemeriksa reviews" |
*
* @param {Settings_Sub_Credits_ReviewerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_credits_reviewer = /** @type {((inputs: Settings_Sub_Credits_ReviewerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_Credits_ReviewerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_credits_reviewer(inputs)
	return en_settings_sub_credits_reviewer(inputs)
});